'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = unitConverter;

var _lodash = require('lodash.isnil');

var _lodash2 = _interopRequireDefault(_lodash);

var _catalytic = require('catalytic');

var _catalytic2 = _interopRequireDefault(_catalytic);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function unitConverter(catalogProduct) {
  var marketProducts = catalogProduct.marketProducts;
  if ((0, _lodash2.default)(marketProducts)) marketProducts = [];

  var types = marketProducts.map(function (marketProduct) {
    return {
      id: marketProduct._id,
      name: marketProduct.name + ' (' + marketProduct.unitLabel + ')',
      qty: marketProduct.yield
    };
  });

  if (!(0, _lodash2.default)(catalogProduct.unitQuantity)) {
    var name = catalogProduct.unitLabel;
    if ((0, _lodash2.default)(name)) name = catalogProduct.name;

    types.push({
      id: 'orderQuantity',
      name: name,
      qty: catalogProduct.unitQuantity
    });
  }

  return (0, _catalytic2.default)({
    baseUnitName: catalogProduct.unitLabel,
    types: types
  });
}
module.exports = exports['default'];